import { Alert, Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import Print from '@mui/icons-material/Print';
import { brand } from '../config/appConfig';
import { useAuth } from '../context/AuthContext';
import { formatDate } from '../utils/format';
import { formatCuil } from '../utils/identity';

export default function Credencial() {
  const { ficha } = useAuth();
  if (!ficha) return null;
  const gremio = brand.clientName || 'El gremio';
  const hoy = formatDate(new Date());

  return (
    <Stack spacing={3}>
      <Typography variant="h5" fontWeight={700} className="no-print">
        Credencial
      </Typography>

      <Box
        sx={{
          maxWidth: 440,
          p: 3,
          borderRadius: 4,
          color: 'primary.contrastText',
          background: (t) => `linear-gradient(135deg, ${t.palette.primary.main}, ${t.palette.primary.dark})`,
          printColorAdjust: 'exact',
          WebkitPrintColorAdjust: 'exact',
        }}
      >
        <Typography variant="body2" sx={{ opacity: 0.85 }}>
          {gremio} · Afiliado/a
        </Typography>
        <Typography variant="h5" fontWeight={700} sx={{ mt: 0.5 }}>
          {ficha.nombre} {ficha.apellido}
        </Typography>
        <Typography sx={{ mt: 2 }}>CUIL {formatCuil(ficha.cuil)}</Typography>
        <Typography variant="body2" sx={{ opacity: 0.85 }}>
          Afiliado/a desde {formatDate(ficha.fecha_alta_sistema)} · {ficha.estado}
        </Typography>
      </Box>

      <Card sx={{ maxWidth: 640 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Constancia de afiliación
          </Typography>
          <Typography>
            {gremio} deja constancia de que <strong>{ficha.nombre} {ficha.apellido}</strong>, CUIL {formatCuil(ficha.cuil)}, figura en el padrón de
            afiliados con estado <strong>{ficha.estado}</strong>, con alta desde el {formatDate(ficha.fecha_alta_sistema)}.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            Emitida el {hoy} desde el portal de afiliados.
          </Typography>
        </CardContent>
      </Card>

      <Stack direction="row" spacing={2} className="no-print">
        <Button variant="contained" startIcon={<Print />} onClick={() => window.print()}>
          Imprimir o guardar como PDF
        </Button>
      </Stack>
      <Alert severity="info" className="no-print" sx={{ maxWidth: 640 }}>
        Esta constancia todavía no tiene un código de verificación. Si un tercero te pide una constancia con validez, pedila al gremio.
      </Alert>
    </Stack>
  );
}
